import { Link } from "react-router-dom";
import { articles as allArticles, categories } from "@/mocks/data";

const featuredArticles = allArticles.slice(0, 6);

const articleImages: Record<string, string> = {
  "shouji-zipai-ru-men-jiqiao": "https://readdy.ai/api/search-image?query=Elegant%20minimal%20photography%20studio%20setup%20with%20warm%20golden%20amber%20lighting%2C%20clean%20aesthetic%20composition%2C%20soft%20natural%20textures%2C%20editorial%20product%20photography%20style%2C%20refined%20atmosphere%20with%20gentle%20shadows%2C%20harmonious%20warm%20tone%20palette%2C%20modern%20smartphone%20on%20wooden%20surface&width=800&height=500&seq=article-selfie-basics&orientation=landscape",
  "guochan-zipai-shenqi-tuijian": "https://readdy.ai/api/search-image?query=Modern%20Chinese%20smartphone%20displayed%20elegantly%20on%20a%20minimal%20wooden%20desk%2C%20warm%20golden%20lighting%2C%20clean%20product%20photography%20style%2C%20refined%20editorial%20look%2C%20soft%20shadows%2C%20harmonious%20amber%20and%20cream%20tones&width=800&height=500&seq=article-device-guide&orientation=landscape",
  "zipai-goutu-fangfa-san-fen-fa": "https://readdy.ai/api/search-image?query=Artistic%20photography%20composition%20concept%20with%20grid%20lines%20overlay%2C%20warm%20golden%20toned%20abstract%20background%2C%20elegant%20minimalist%20design%2C%20editorial%20photography%20aesthetic%2C%20refined%20studio%20atmosphere%2C%20soft%20natural%20light%20and%20gentle%20shadows&width=800&height=500&seq=article-composition&orientation=landscape",
  "shouji-xiu-tu-app-tui-jian": "https://readdy.ai/api/search-image?query=Elegant%20smartphone%20displaying%20photo%20editing%20interface%20on%20a%20clean%20desk%2C%20warm%20ambient%20lighting%2C%20minimalist%20editorial%20product%20photography%2C%20soft%20golden%20and%20cream%20tones%2C%20refined%20modern%20aesthetic&width=800&height=500&seq=article-editing-apps&orientation=landscape",
  "zipai-dengguang-buzhi-jiaocheng": "https://readdy.ai/api/search-image?query=Professional%20ring%20light%20and%20photography%20lighting%20setup%20in%20a%20minimal%20studio%2C%20warm%20golden%20glow%2C%20elegant%20product%20photography%20style%2C%20soft%20shadows%2C%20refined%20amber%20and%20cream%20color%20palette%2C%20editorial%20quality&width=800&height=500&seq=article-lighting&orientation=landscape",
  "guochan-shouji-meiyan-shezhi": "https://readdy.ai/api/search-image?query=Elegant%20cosmetic%20and%20beauty%20products%20arranged%20on%20a%20minimal%20vanity%20desk%2C%20warm%20soft%20lighting%2C%20refined%20editorial%20product%20photography%2C%20golden%20and%20rose%20tones%2C%20clean%20aesthetic%20composition%2C%20delicate%20atmosphere&width=800&height=500&seq=article-beauty-mode&orientation=landscape",
};

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-sm text-foreground-600">
              最受欢迎的自拍干货，从入门到进阶
            </p>
          </div>
          <Link
            to="/category/jiqiao"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={articleImages[article.slug] || ""}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    {cat && (
                      <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-100/80 text-accent-700 whitespace-nowrap">
                        {cat.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-500">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-2 mt-4 text-xs text-foreground-500">
                    <span>{article.author}</span>
                    <span>·</span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}